export default "__VITE_ASSET__D95_Jtkr__"